/* =============================================================================
   ZAHWA — homepage section behaviour (scoped, no jQuery dependency)
   1) Mood filter: filters the scent grid by zahwa.mood. Resilient — if this
      script fails to load/run, NO card is hidden (all products stay visible).
   2) Quick-add: progressive enhancement over a real {% form 'product' %}.
      Without JS the form posts normally to /cart/add. With JS it adds via
      /cart/add.js then opens Debutify's cart drawer (which refreshes itself via
      onDrawerOpen: ajaxCart.load). No Debutify core JS is modified.
============================================================================= */
(function () {
  'use strict';

  /* ---- Mood filter -------------------------------------------------------- */
  function applyFilter(mood) {
    var cards = document.querySelectorAll('[data-zahwa-scent-card]');
    var shown = 0;
    for (var i = 0; i < cards.length; i++) {
      var moods = (cards[i].getAttribute('data-moods') || '').split(/\s+/);
      var match = (mood === 'all') || moods.indexOf(mood) !== -1;
      cards[i].hidden = !match;
      cards[i].classList.toggle('is-hidden', !match);
      if (match) shown++;
    }
    var empty = document.querySelector('[data-zahwa-empty]');
    if (empty) empty.hidden = (shown !== 0);
  }

  function initMoodFilter() {
    var groups = document.querySelectorAll('[data-zahwa-mood-filter]');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        var chips = group.querySelectorAll('.zw-chip');
        for (var c = 0; c < chips.length; c++) {
          chips[c].addEventListener('click', function () {
            var chip = this;
            for (var k = 0; k < chips.length; k++) {
              var on = chips[k] === chip;
              chips[k].classList.toggle('is-active', on);
              chips[k].setAttribute('aria-pressed', on ? 'true' : 'false');
            }
            applyFilter(chip.getAttribute('data-mood') || 'all');
          });
        }
      })(groups[g]);
    }
  }

  /* ---- Quick-add (progressive enhancement) -------------------------------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form.zw-quickadd') : null;
      if (!form) return;
      if (!window.fetch || !window.FormData) return; // no fetch -> let it POST normally
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          var opener = document.querySelector('.js-drawer-open-button-right');
          if (opener) { opener.click(); }          // Debutify drawer refreshes via onDrawerOpen: ajaxCart.load
          else { window.location.href = '/cart'; } // drawer off -> go to cart page
        })
        .catch(function () { form.submit(); })       // hard fallback: native post
        .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
    }, false);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initMoodFilter(); initQuickAdd(); });
})();
